import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
} from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { NGXS_PLUGINS, NgxsModule } from '@ngxs/store';
import { LoadingState } from './store/loading/loading.state';
import {
  NgxsStoragePluginModule,
  LOCAL_STORAGE_ENGINE,
} from '@ngxs/storage-plugin';
import { AuthState } from './store/auth/auth.state';
import { environment } from '../environments/environment';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { ExitPointsState } from './store/exit-points/exit-points.state';
import { CustomersState } from './store/customers/customers.state';
import { DemandState } from './store/demand/demand.state';
import { SectorsState } from './store/sectors/sectors.state';
import { SectionsState } from './store/sections/sections.state';
import { TypeMarketState } from './store/type-market/type-market.state';
import { logoutPlugin } from './store/store-logout-plugin/store-logout-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { GasSourcesState } from './store/gas-sources/gas-sources.state';
import { SocietiesState } from './store/societies/societies.state';
import { CitiesState } from './store/cities/cities.state';
import { RelevantMarketsState } from './store/relevant-markets/relevant-markets.store';
import { DistributionSystemsState } from './store/distribution-systems/distribution-systems.state';
import { GeneralFilterState } from './store/general-filter/general-filter.state';
import { StandarPredictionState } from './store/prediction/standar-prediction.store';
import { ConsumptionsState } from './store/consumption/consumption.store';
import { CustomerPredictionState } from './store/customer-prediction/customer-prediction.store';
import { ExitPointPredictionState } from './store/exit-point-prediction/exit-point-prediction.store';
import { DesviationPredictionState } from './store/desviation-prediction/desviation-prediction.store';
import { ATRState } from './store/atr/atr.store';
import { StandardPredictionState } from './store/standard-prediction/standard-prediction.state';
import { EstacionalPredictionState } from './store/estacional-prediction/estacional-prediction.state';
import { SeasonalPredictionState } from './store/seasonal-prediction/seasonal-prediction.store';
import { SeasonalDetailState } from './store/seasonal-detail/seasonal-detail.state';
import { SsoState } from './store/sso/sso.state';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { loadingQueueInterceptor } from './core/interceptors/loading-queue.interceptor';
import { GiState } from './store/gi/gi.state';
import { FineAdjustmentState } from './store/fine-adjustment/fine-adjustment.state';
import { CustomerAdjustmentHistoryState } from './store/customer-adjustment-history/customer-adjustment-history.state';
import { ExitPointsAdjustmentHistoryState } from './store/exit-points-adjustment-history/exit-points-adjustment-history.state';
import { CityGatesState } from './store/city-gates/city-gates.state';
import { AgentsState } from './store/agents/agents.state';
import { RolAgenteState } from './store/rol-agente/rol-agente.state';
import { CalorificPowerState } from './store/calorific-power/calorific-power.state';
import { PoderCalorificoNominationState } from './store/poder-calorifico-nomination/poder-calorifico-nomination.state';

// Registrar datos de locale español
registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, loadingQueueInterceptor]) // Usar enfoque funcional
    ),
    importProvidersFrom(
      NgxsModule.forRoot(
        [
          LoadingState,
          ExitPointsState,
          CustomersState,
          DemandState,
          SectorsState,
          SectionsState,
          TypeMarketState,
          GasSourcesState,
          SocietiesState,
          CitiesState,
          RelevantMarketsState,
          DistributionSystemsState,
          GeneralFilterState,
          StandarPredictionState,
          ConsumptionsState,
          CustomerPredictionState,
          ExitPointPredictionState,
          DesviationPredictionState,
          ATRState,
          StandardPredictionState,
          EstacionalPredictionState,
          SeasonalPredictionState,
          SeasonalDetailState,
          SsoState,
          GiState,
          FineAdjustmentState,
          CustomerAdjustmentHistoryState,
          ExitPointsAdjustmentHistoryState,
          CityGatesState,
          AgentsState,
          RolAgenteState,
          CalorificPowerState,
          PoderCalorificoNominationState,
        ],
        {
          developmentMode: !environment.production,
        }
      ),
      NgxsStoragePluginModule.forRoot({
        key: [
          { key: 'sso', engine: LOCAL_STORAGE_ENGINE },
          { key: AuthState, engine: LOCAL_STORAGE_ENGINE },
          {
            key: 'standardPrediction.selectedTab',
            engine: LOCAL_STORAGE_ENGINE,
          },
          {
            key: 'estacionalPrediction.selectedTabHome',
            engine: LOCAL_STORAGE_ENGINE,
          },
        ],
      }),
      NgxsReduxDevtoolsPluginModule.forRoot(),
      MatNativeDateModule
    ),
    {
      provide: NGXS_PLUGINS,
      useValue: logoutPlugin,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'es',
    },
  ],
};
